export default __webpack_public_path__ + "static/media/offer-1-1f7a4c9ea0ba5a216bc7af1f60d044e0.6e919f19.png";